/* Profile section + shared chart anatomy (after RevenueOverTimeChart) */

.section {
  min-width: 0;
}

.header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: var(--space-4);
  margin-bottom: var(--space-4);
  flex-wrap: wrap;
}

.heading {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
}

.titleRow {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.title {
  margin: 0;
  font-size: var(--text-2xl);
  font-weight: var(--weight-bold);
  color: var(--text-primary);
}

.scope {
  margin: 0;
  font-size: var(--text-sm);
  color: var(--text-muted);
}

.hintIcon {
  color: var(--text-disabled);
  cursor: help;
}

.hintIcon:hover {
  color: var(--text-secondary);
}

/* "| Full leaderboard" after the title, as Home's Top 10s heading */
.titleDivider {
  margin: 0 var(--space-1);
  color: var(--border-strong);
}

.titleLink {
  font-size: var(--text-base);
  white-space: nowrap;
  color: var(--text-muted);
  text-decoration: none;
  transition: color var(--duration-fast) var(--ease-default);
}

.titleLink:hover {
  color: var(--accent-secondary-text);
}

.controls {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  flex-wrap: wrap;
  margin-left: auto;
}

.box {
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  background: linear-gradient(to bottom, var(--bg-surface), var(--bg-card));
  overflow: hidden;
  min-width: 0;
}

/* ── Chart anatomy ── */

.summary {
  margin: var(--space-5) var(--space-5) var(--space-4);
  max-width: 110ch;
}

.toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--space-4);
  padding: var(--space-2) var(--space-5);
  border-top: 1px solid var(--border-subtle);
  border-bottom: 1px solid var(--border-subtle);
  flex-wrap: wrap;
}

.toolbarGroup {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.toolbarLabel {
  font-size: var(--text-xs);
  font-weight: var(--weight-bold);
  text-transform: uppercase;
  letter-spacing: var(--tracking-caps);
  color: var(--text-muted);
}

.body {
  padding: var(--space-4) var(--space-5) var(--space-5);
  min-width: 0;
}

/* Y titles in their own columns beside the plot, so they never meet the ticks */
.plot {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
}

.yAxisTitle {
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  white-space: nowrap;
  font-size: var(--text-sm);
  font-weight: var(--weight-bold);
  color: var(--text-secondary);
}

.yAxisTitleLeft {
  margin-right: var(--space-2);
}

.yAxisTitleRight {
  margin-left: var(--space-2);
}

.quarterTick {
  font-size: 13px;
  fill: var(--text-muted);
}

.quarterTickYear {
  fill: var(--text-disabled);
}

/* Bar / point value labels — Bebas, as d360 */
.valueLabel {
  font-family: var(--font-display);
  font-size: 17px;
  letter-spacing: 0.03em;
  fill: var(--text-primary);
  /* Halo in the card colour, so a label crossing a neighbouring bar stays legible */
  paint-order: stroke;
  stroke: var(--bg-card);
  stroke-width: 4px;
  stroke-linejoin: round;
}

.segmentLabel {
  font-family: var(--font-display);
  font-size: 13px;
  letter-spacing: 0.02em;
  fill: var(--text-on-accent, var(--text-primary));
  pointer-events: none;
}

/* Axis tick labels. Recharts renders them as .recharts-cartesian-axis-tick-value
   inside the axis layer, which takes this class. */
.axis :global(.recharts-cartesian-axis-tick-value) {
  fill: var(--text-muted);
  font-size: 13px;
}

.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 240px;
  color: var(--text-muted);
  font-size: var(--text-sm);
}
